import React from 'react';
import { Badge } from '@/components/ui/badge';
import { ROLE_LABELS, ROLE_ACCENT } from '@/lib/constants';

export function RoleBadge({ role, className = '' }) {
  const label = ROLE_LABELS[role] || role;
  const color = ROLE_ACCENT[role] || 'var(--muted-foreground)';
  return (
    <Badge
      variant="outline"
      className={`font-medium ${className}`}
      style={{ borderColor: `hsl(${color} / 0.35)`, color: `hsl(${color})`, backgroundColor: `hsl(${color} / 0.08)` }}
      data-testid="role-badge"
    >
      {label}
    </Badge>
  );
}
